import { render, staticRenderFns } from "./StallionTwoLastCampagnes.vue?vue&type=template&id=866f321a&"
import script from "./StallionTwoLastCampagnes.vue?vue&type=script&lang=js&"
export * from "./StallionTwoLastCampagnes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports